export interface InventoryItem {
  id: string
  title: string
  category: string
  price: string
  status: string
  talabPublished: boolean
  aiScore: number
  views: number
  rules: string
  leads: number
  validityDays: number
  totalValidity: number
  alert?: boolean
  // Primary thumbnail used by the catalogue list/table views.
  image: string
  // Buyer-facing presentation, shared with the Discover listing card.
  location: string
  images: string[]
  specs: {
    label: string
    value: string
  }[]
}
const PRADO =
  'https://images.unsplash.com/photo-1550133730-695473e544be?auto=format&fit=crop&q=80&w=800'
const PRADO_ALT =
  'https://images.unsplash.com/photo-1590362891991-f776e747a588?auto=format&fit=crop&q=80&w=800'
const PATROL =
  'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&q=80&w=800'
const YARIS =
  'https://images.unsplash.com/photo-1590362891991-f776e747a588?auto=format&fit=crop&q=80&w=800'
const RANGE_SPORT =
  'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?auto=format&fit=crop&q=80&w=800'
const RANGE_EVOQUE =
  'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&q=80&w=800'
const G63 =
  'https://images.unsplash.com/photo-1520031441872-265e4ff70366?auto=format&fit=crop&q=80&w=800'
const BMW =
  'https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&q=80&w=800'
const CAMRY =
  'https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?auto=format&fit=crop&q=80&w=800'
export const inventoryItems: InventoryItem[] = [
  {
    id: '1',
    title: 'Toyota Prado GXR 2018',
    category: 'SUVs',
    price: 'AED 350/day',
    status: 'Available',
    talabPublished: true,
    aiScore: 92,
    views: 1240,
    rules: 'Delivery configured',
    leads: 18,
    validityDays: 12,
    totalValidity: 30,
    image: PRADO,
    location: 'Al Quoz, Dubai',
    images: [PRADO, PRADO_ALT],
    specs: [
      {
        label: 'Year',
        value: '2018',
      },
      {
        label: 'Seats',
        value: '7 Seats',
      },
      {
        label: 'Transmission',
        value: 'Automatic',
      },
      {
        label: 'Deposit',
        value: 'AED 1,500',
      },
    ],
  },
  {
    id: '2',
    title: 'Nissan Patrol 2020',
    category: 'SUVs',
    price: 'AED 450/day',
    status: 'Available',
    talabPublished: true,
    aiScore: 76,
    views: 2180,
    rules: 'Missing airport pickup rule',
    leads: 24,
    validityDays: 5,
    totalValidity: 30,
    alert: true,
    image: PATROL,
    location: 'Business Bay, Dubai',
    images: [PATROL, PRADO],
    specs: [
      {
        label: 'Year',
        value: '2020',
      },
      {
        label: 'Seats',
        value: '7 Seats',
      },
      {
        label: 'Transmission',
        value: 'Automatic',
      },
      {
        label: 'Deposit',
        value: 'AED 2,000',
      },
    ],
  },
  {
    id: '3',
    title: 'Toyota Yaris 2022',
    category: 'Hatchbacks',
    price: 'AED 120/day',
    status: 'Inventory',
    talabPublished: false,
    aiScore: 41,
    views: 0,
    rules: 'Needs pricing rules',
    leads: 0,
    validityDays: 30,
    totalValidity: 30,
    alert: true,
    image: YARIS,
    location: 'Al Barsha, Dubai',
    images: [YARIS, CAMRY],
    specs: [
      {
        label: 'Year',
        value: '2022',
      },
      {
        label: 'Seats',
        value: '5 Seats',
      },
      {
        label: 'Transmission',
        value: 'Automatic',
      },
      {
        label: 'Deposit',
        value: 'AED 700',
      },
    ],
  },
  {
    id: '4',
    title: 'Range Rover Sport 2021',
    category: 'SUVs',
    price: 'AED 850/day',
    status: 'Available',
    talabPublished: true,
    aiScore: 95,
    views: 3120,
    rules: 'Chauffeur option configured',
    leads: 41,
    validityDays: 22,
    totalValidity: 30,
    image: RANGE_SPORT,
    location: 'Downtown Dubai',
    images: [RANGE_SPORT, RANGE_EVOQUE],
    specs: [
      {
        label: 'Year',
        value: '2021',
      },
      {
        label: 'Seats',
        value: '5 Seats',
      },
      {
        label: 'Transmission',
        value: 'Automatic',
      },
      {
        label: 'Deposit',
        value: 'AED 3,000',
      },
    ],
  },
  {
    id: '5',
    title: 'Range Rover Evoque 2022',
    category: 'SUVs',
    price: 'AED 520/day',
    status: 'Available',
    talabPublished: true,
    aiScore: 88,
    views: 1760,
    rules: 'Delivery configured',
    leads: 27,
    validityDays: 18,
    totalValidity: 30,
    image: RANGE_EVOQUE,
    location: 'Dubai Marina',
    images: [RANGE_EVOQUE, RANGE_SPORT],
    specs: [
      {
        label: 'Year',
        value: '2022',
      },
      {
        label: 'Seats',
        value: '5 Seats',
      },
      {
        label: 'Transmission',
        value: 'Automatic',
      },
      {
        label: 'Deposit',
        value: 'AED 2,000',
      },
    ],
  },
  {
    id: '6',
    title: 'Mercedes-Benz G63 2023',
    category: 'SUVs',
    price: 'AED 1,650/day',
    status: 'Available',
    talabPublished: true,
    aiScore: 90,
    views: 2640,
    rules: 'Deposit rule configured',
    leads: 33,
    validityDays: 27,
    totalValidity: 30,
    image: G63,
    location: 'Jumeirah, Dubai',
    images: [G63, RANGE_SPORT],
    specs: [
      {
        label: 'Year',
        value: '2023',
      },
      {
        label: 'Seats',
        value: '5 Seats',
      },
      {
        label: 'Transmission',
        value: 'Automatic',
      },
      {
        label: 'Deposit',
        value: 'AED 5,000',
      },
    ],
  },
  {
    id: '7',
    title: 'BMW 520i 2022',
    category: 'Sedans',
    price: 'AED 320/day',
    status: 'Available',
    talabPublished: true,
    aiScore: 84,
    views: 980,
    rules: 'Mileage cap configured',
    leads: 12,
    validityDays: 9,
    totalValidity: 30,
    image: BMW,
    location: 'Deira, Dubai',
    images: [BMW, CAMRY],
    specs: [
      {
        label: 'Year',
        value: '2022',
      },
      {
        label: 'Seats',
        value: '5 Seats',
      },
      {
        label: 'Transmission',
        value: 'Automatic',
      },
      {
        label: 'Deposit',
        value: 'AED 1,500',
      },
    ],
  },
  {
    id: '8',
    title: 'Toyota Camry 2021',
    category: 'Sedans',
    price: 'AED 180/day',
    status: 'Inventory',
    talabPublished: false,
    aiScore: 58,
    views: 0,
    rules: 'Needs pricing rules',
    leads: 0,
    validityDays: 30,
    totalValidity: 30,
    image: CAMRY,
    location: 'Al Nahda, Sharjah',
    images: [CAMRY, BMW],
    specs: [
      {
        label: 'Year',
        value: '2021',
      },
      {
        label: 'Seats',
        value: '5 Seats',
      },
      {
        label: 'Transmission',
        value: 'Automatic',
      },
      {
        label: 'Deposit',
        value: 'AED 1,000',
      },
    ],
  },
]
